import { isDate as Nt } from "../../util/code-utils.js";
import {
  convertMsToSeconds as l,
  dateFromUnixTimestamp as h,
  secondsAgo as Qt,
  secondsInTheFuture as Wt
} from "../../util/date-utils.js";
export default class Vt {
  constructor(t, s, e, i) {
    (this.Ql = t),
      (this.Xl = s),
      (this.comparator = e),
      (this.Vl = i),
      this.Xl === Vt.Wl.Kl &&
        this.comparator !== Vt.Zl.Yl &&
        this.comparator !== Vt.Zl.Uh &&
        this.comparator !== Vt.Zl.Qh &&
        this.comparator !== Vt.Zl.Xh &&
        (this.Vl = h(this.Vl));
  }
  Gl(t) {
    let s = null;
    switch ((null != t && (s = t[this.Ql]), this.comparator)) {
      case Vt.Zl.Vh:
        return null != s && s.valueOf() === this.Vl.valueOf();
      case Vt.Zl.Kh:
        return null == s || s.valueOf() !== this.Vl.valueOf();
      case Vt.Zl.Yh:
        return typeof s == typeof this.Vl && s > this.Vl;
      case Vt.Zl.Yl:
        return this.Xl === Vt.Wl.Kl
          ? null != s && Nt(s) && Qt(s) <= this.Vl
          : typeof s == typeof this.Vl && s >= this.Vl;
      case Vt.Zl.Zh:
        return typeof s == typeof this.Vl && s < this.Vl;
      case Vt.Zl.Uh:
        return this.Xl === Vt.Wl.Kl
          ? null != s && Nt(s) && Qt(s) >= this.Vl
          : typeof s == typeof this.Vl && s <= this.Vl;
      case Vt.Zl.$h:
        return (
          null != s &&
          "string" == typeof s &&
          typeof s == typeof this.Vl &&
          null != s.match(this.Vl)
        );
      case Vt.Zl.Eu:
        return null != s;
      case Vt.Zl.au:
        return null == s;
      case Vt.Zl.Qh:
        return null != s && Nt(s) && Wt(s) < this.Vl;
      case Vt.Zl.Xh:
        return null != s && Nt(s) && Wt(s) > this.Vl;
      case Vt.Zl.Tu:
        return (
          null == s ||
          typeof s != typeof this.Vl ||
          "string" != typeof s ||
          null == s.match(this.Vl)
        );
    }
    return !1;
  }
  static fromJson(t) {
    return new Vt(
      t.property_key,
      t.property_type,
      t.comparator,
      t.property_value
    );
  }
  ss() {
    let t = this.Vl;
    return (
      Nt(this.Vl) && (t = l(t.valueOf())),
      { k: this.Ql, t: this.Xl, c: this.comparator, v: t }
    );
  }
  static Pn(t) {
    return new Vt(t.k, t.t, t.c, t.v);
  }
}
(Vt.Zl = {
  Vh: 1,
  Kh: 2,
  Yh: 3,
  Yl: 4,
  Zh: 5,
  Uh: 6,
  $h: 10,
  Eu: 11,
  au: 12,
  Qh: 15,
  Xh: 16,
  Tu: 17
}),
  (Vt.Wl = { Au: "boolean", _u: "number", fu: "string", Kl: "date" });
